import { createFileRoute, redirect } from '@tanstack/react-router'
import { DesaDashboardLayout } from '../../../../components/DashboardLayout'

async function fetchUserProfile() {
  const res = await fetch('/api/users/me', { credentials: 'include' })
  if (!res.ok) return null
  return res.json()
}

async function fetchDesaBySlug(slug: string) {
  const res = await fetch(`/api/public/desa/${slug}`, { credentials: 'include' })
  if (!res.ok) return null
  return res.json()
}

export const Route = createFileRoute('/desa/$slug/dashboard')({
  beforeLoad: async ({ params }) => {
    try {
      const user = await fetchUserProfile()
      if (!user) throw new Error('not authenticated')

      // Resolve slug → desa
      const desa = await fetchDesaBySlug(params.slug)
      if (!desa) throw redirect({ to: '/parkir' })

      // Platform admin dan is_qc bisa akses dashboard desa manapun
      if (user.role === 'platform_admin' || user.is_qc) {
        return { user, desa, desaId: desa.id }
      }

      // Staff harus approved, punya desa, dan slug harus match
      const staffRoles = ['kepala_desa', 'sekretaris_desa', 'operator_desa']
      if (!staffRoles.includes(user.role)) {
        throw redirect({ to: '/parkir' })
      }

      if (user.status !== 'approved') {
        throw redirect({ to: '/parkir' })
      }

      if (user.desa_id !== desa.id) {
        // Staff coba akses desa lain → redirect ke desa sendiri
        const ownSlug = user.desa?.slug
        if (ownSlug) throw redirect({ to: `/desa/${ownSlug}/dashboard` as any })
        throw redirect({ to: '/parkir' })
      }

      return { user, desa, desaId: desa.id }
    } catch (e) {
      if ((e as any)?.to) throw e
      throw redirect({ to: '/login' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { slug } = Route.useParams()
  const { desa } = Route.useRouteContext() as any
  return <DesaDashboardLayout slug={slug} desa={desa} />
}
